import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import Buy from "./Buy";
import Sell from "./Sell";
import Financing from "./Financing";
import FrequentQuestions from "./FrequentQuestions";
import Pictures from "./Pictures";

export const frequentQuestionSubRoutes: RouteObject[] = [
    {
        title: "Comprar",
        path: "comprar",
        component: <Buy />
    },
    {
        title: "Vender",
        path: "vender",
        component: <Sell />
    },
    {
        title: "Financiamiento",
        path: "financiamiento",
        component: <Financing />
    },
    {
        title: "Imágenes",
        path: "imagenes",
        component: <Pictures />
    },
];

export const frequentQuestionRoutes: RouteObject[] = [
    {
        title: "Frequent Questions",
        path: "/preguntas-frecuentes",
        component: <FrequentQuestions/>,
        subRoutes: frequentQuestionSubRoutes
    }
];